/* ==========================================================================
   Vault Luxe — theme.js
   Vanilla JS progressive enhancement: mobile nav, smooth scroll to inquiry
   forms, product gallery thumbnails, hover-zoom, and collection filter/sort
   submission. No external dependencies.
   ========================================================================== */
(function () {
  'use strict';

  document.documentElement.classList.remove('no-js');

  /* ---------- Analytics: lead-event helper ----------
     This site has no cart/checkout, so Purchase/AddToCart never fire. Called
     from the Contact, Sell Your Rolex, and product-inquiry form success
     states (see snippets/analytics.liquid for the loaders this depends on).
     No-ops safely if GA4/Meta Pixel aren't configured in Theme settings. */
  window.rcTrackLead = function (source) {
    if (typeof window.gtag === 'function') {
      window.gtag('event', 'generate_lead', { form_source: source });
    }
    if (typeof window.fbq === 'function') {
      window.fbq('track', 'Lead', { content_name: source });
    }
  };

  /* ---------- Mobile drawer ---------- */
  var drawer = document.getElementById('MobileDrawer');
  var toggles = document.querySelectorAll('[data-drawer-toggle]');

  function setDrawer(open) {
    if (!drawer) return;
    if (open) {
      drawer.setAttribute('data-open', '');
      drawer.removeAttribute('aria-hidden');
      document.body.style.overflow = 'hidden';
    } else {
      drawer.removeAttribute('data-open');
      drawer.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
    }
    var menuToggle = document.querySelector('.site-header__menu-toggle');
    if (menuToggle) menuToggle.setAttribute('aria-expanded', open ? 'true' : 'false');
  }

  toggles.forEach(function (btn) {
    btn.addEventListener('click', function () {
      var isOpen = drawer && drawer.hasAttribute('data-open');
      setDrawer(!isOpen);
    });
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && drawer && drawer.hasAttribute('data-open')) setDrawer(false);
  });

  /* ---------- Mobile accordion submenus ---------- */
  document.querySelectorAll('[data-accordion-toggle]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var panel = btn.nextElementSibling;
      if (!panel) return;
      var isOpen = panel.hasAttribute('data-open');
      document.querySelectorAll('[data-accordion-panel]').forEach(function (p) {
        p.removeAttribute('data-open');
      });
      if (!isOpen) panel.setAttribute('data-open', '');
    });
  });

  /* ---------- Smooth scroll with sticky-header offset ---------- */
  document.querySelectorAll('[data-scroll-to]').forEach(function (link) {
    link.addEventListener('click', function (e) {
      var targetId = link.getAttribute('data-scroll-to');
      var target = document.getElementById(targetId);
      if (!target) return;
      e.preventDefault();
      var header = document.querySelector('[data-header]');
      var offset = (header ? header.offsetHeight : 0) + 16;
      var top = target.getBoundingClientRect().top + window.pageYOffset - offset;
      window.scrollTo({ top: top, behavior: 'smooth' });
      var firstField = target.querySelector('input, textarea, select');
      if (firstField) window.setTimeout(function () { firstField.focus({ preventScroll: true }); }, 500);
    });
  });

  /* ---------- Product gallery: thumbnails + hover zoom ---------- */
  var galleryMain = document.querySelector('[data-product-gallery] .product-gallery__main');
  var mainImage = document.getElementById('ProductMainImage');

  document.querySelectorAll('[data-thumb]').forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      if (!mainImage) return;
      // Shopify's image_tag adds a srcset that otherwise overrides a plain
      // src swap, so the browser keeps showing the old image on click.
      mainImage.removeAttribute('srcset');
      mainImage.removeAttribute('sizes');
      mainImage.src = thumb.getAttribute('data-full');
      mainImage.alt = thumb.getAttribute('data-alt') || mainImage.alt;
      document.querySelectorAll('[data-thumb]').forEach(function (t) { t.removeAttribute('data-active'); });
      thumb.setAttribute('data-active', '');
    });
  });

  if (galleryMain && mainImage) {
    var supportsHoverZoom = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
    if (supportsHoverZoom) {
      galleryMain.addEventListener('mousemove', function (e) {
        var rect = galleryMain.getBoundingClientRect();
        var x = ((e.clientX - rect.left) / rect.width) * 100;
        var y = ((e.clientY - rect.top) / rect.height) * 100;
        x = Math.max(0, Math.min(100, x));
        y = Math.max(0, Math.min(100, y));
        mainImage.style.transformOrigin = x + '% ' + y + '%';
        galleryMain.classList.add('is-zoomed');
      });
      galleryMain.addEventListener('mouseleave', function () {
        galleryMain.classList.remove('is-zoomed');
        mainImage.style.transformOrigin = 'center center';
      });
    }
  }

  /* ---------- Collection sort ---------- */
  var sortSelect = document.querySelector('[data-sort-select]');
  if (sortSelect) {
    sortSelect.addEventListener('change', function () {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', sortSelect.value);
      window.location.href = url.toString();
    });
  }

  /* ---------- Collection filters (auto-submit on change) ---------- */
  var filterForm = document.getElementById('FacetFilterForm');
  if (filterForm) {
    filterForm.querySelectorAll('[data-filter-input]').forEach(function (input) {
      input.addEventListener('change', function () {
        filterForm.requestSubmit ? filterForm.requestSubmit() : filterForm.submit();
      });
    });
  }

  /* ---------- Marquee pause/play (WCAG 2.2.2: user control for auto-scrolling content) ---------- */
  document.querySelectorAll('[data-marquee-toggle]').forEach(function (btn) {
    var marquee = btn.closest('.marquee');
    if (!marquee) return;
    var pauseIcon = btn.querySelector('[data-marquee-icon-pause]');
    var playIcon = btn.querySelector('[data-marquee-icon-play]');
    var label = btn.querySelector('[data-marquee-label]');

    btn.addEventListener('click', function () {
      var isPaused = marquee.classList.toggle('is-paused');
      btn.setAttribute('aria-pressed', isPaused ? 'true' : 'false');
      if (label) label.textContent = isPaused ? 'Resume scrolling' : 'Pause scrolling';
      if (pauseIcon) pauseIcon.hidden = isPaused;
      if (playIcon) playIcon.hidden = !isPaused;
    });
  });

  /* ---------- Draggable/swipeable marquee (New Stock, Reviews) ----------
     Replaces the CSS keyframe animation with a JS-driven translateX so the
     same continuous auto-scroll can be nudged by a finger on mobile or a
     two-finger trackpad swipe on desktop, then pick back up smoothly from
     wherever it was let go — a CSS animation alone can't be offset like this.
     Auto-scroll direction follows .marquee--reverse (see theme.css), which
     otherwise only flips a CSS animation-direction that no longer runs once
     the animation itself is switched off for these marquees; drag/swipe
     input always follows the finger/trackpad regardless of that direction. */
  var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (!reducedMotion) {
    document.querySelectorAll('[data-draggable-marquee]').forEach(function (marquee) {
      var track = marquee.querySelector('.marquee__track');
      if (!track) return;

      var autoDirection = marquee.classList.contains('marquee--reverse') ? 1 : -1;
      var offset = 0;
      var half = 0;
      var speed = 0; // px per ms
      var lastTime = null;
      var dragging = false;
      var dragMoved = false;
      var dragStartX = 0;
      var dragStartOffset = 0;
      var wheelActive = false;
      var wheelTimer = null;
      var hoverPaused = false;
      var focusPaused = false;

      function measure() {
        half = track.scrollWidth / 2;
        var duration = parseFloat(getComputedStyle(marquee).getPropertyValue('--marquee-duration')) || 55;
        speed = half / (duration * 1000);
      }
      measure();
      window.addEventListener('resize', measure);

      function normalize() {
        if (half <= 0) return;
        while (offset <= -half) offset += half;
        while (offset > 0) offset -= half;
      }

      function apply() {
        track.style.transform = 'translateX(' + offset + 'px)';
      }

      function isPaused() {
        return dragging || wheelActive || hoverPaused || focusPaused || marquee.classList.contains('is-paused');
      }

      function tick(time) {
        if (lastTime === null) lastTime = time;
        var dt = time - lastTime;
        lastTime = time;
        if (!isPaused()) {
          offset += autoDirection * speed * dt;
          normalize();
          apply();
        }
        requestAnimationFrame(tick);
      }
      requestAnimationFrame(tick);

      marquee.addEventListener('mouseenter', function () { hoverPaused = true; });
      marquee.addEventListener('mouseleave', function () { hoverPaused = false; lastTime = null; });
      marquee.addEventListener('focusin', function () { focusPaused = true; });
      marquee.addEventListener('focusout', function () { focusPaused = false; lastTime = null; });

      /* Touch: finger swipe on mobile */
      marquee.addEventListener('touchstart', function (e) {
        if (!e.touches.length) return;
        dragging = true;
        dragMoved = false;
        dragStartX = e.touches[0].clientX;
        dragStartOffset = offset;
      }, { passive: true });

      marquee.addEventListener('touchmove', function (e) {
        if (!dragging || !e.touches.length) return;
        var delta = e.touches[0].clientX - dragStartX;
        if (Math.abs(delta) > 6) dragMoved = true;
        offset = dragStartOffset + delta;
        normalize();
        apply();
      }, { passive: true });

      marquee.addEventListener('touchend', function () {
        dragging = false;
        lastTime = null;
      });

      // A finger that moved was a swipe, not a tap — don't let the browser
      // also navigate through to the product page underneath it.
      track.querySelectorAll('a').forEach(function (link) {
        link.addEventListener('click', function (e) {
          if (dragMoved) {
            e.preventDefault();
            dragMoved = false;
          }
        });
      });

      /* Trackpad: two-finger horizontal swipe (wheel deltaX) */
      marquee.addEventListener('wheel', function (e) {
        if (Math.abs(e.deltaX) <= Math.abs(e.deltaY)) return; // vertical scroll: let the page handle it
        e.preventDefault();
        offset -= e.deltaX;
        normalize();
        apply();
        wheelActive = true;
        clearTimeout(wheelTimer);
        wheelTimer = setTimeout(function () { wheelActive = false; lastTime = null; }, 200);
      }, { passive: false });
    });
  }

  /* ---------- Smooth accordions (FAQ, product-page Warranty/Authenticity/Learn More) ----------
     Native <details> snaps open/closed instantly with no way to transition the
     display:none swap in every browser yet, so this intercepts the toggle and
     animates .faq-item__answer's max-height (set to 0 by default in CSS)
     instead, while still flipping the real `open` attribute in sync so
     keyboard/no-JS/assistive-tech behavior is unchanged. */
  var reduceMotionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
  document.querySelectorAll('.faq-item').forEach(function (item) {
    var summary = item.querySelector('summary');
    var answer = item.querySelector('.faq-item__answer');
    if (!summary || !answer) return;

    summary.addEventListener('click', function (e) {
      if (reduceMotionQuery.matches) return; // let the browser's instant native toggle happen
      e.preventDefault();

      answer.removeEventListener('transitionend', answer._onSmoothToggleEnd || function () {});

      if (item.hasAttribute('open')) {
        var closedFrom = answer.scrollHeight;
        answer.style.maxHeight = closedFrom + 'px';
        requestAnimationFrame(function () {
          requestAnimationFrame(function () { answer.style.maxHeight = '0px'; });
        });
        answer._onSmoothToggleEnd = function onClose(ev) {
          if (ev.propertyName !== 'max-height') return;
          item.removeAttribute('open');
          answer.style.maxHeight = '';
          answer.removeEventListener('transitionend', onClose);
        };
        answer.addEventListener('transitionend', answer._onSmoothToggleEnd);
      } else {
        item.setAttribute('open', '');
        var openTo = answer.scrollHeight;
        answer.style.maxHeight = '0px';
        requestAnimationFrame(function () {
          requestAnimationFrame(function () { answer.style.maxHeight = openTo + 'px'; });
        });
        answer._onSmoothToggleEnd = function onOpen(ev) {
          if (ev.propertyName !== 'max-height') return;
          // 'none', not '' — clearing the inline style falls back to the
          // stylesheet's own max-height:0 (needed for the closed default),
          // which snapped the panel shut again right after it finished
          // opening. 'none' lifts the clip with no numeric value to fall
          // back to, and a transition can't animate to/from 'none' anyway
          // (spec-defined), so the next close's max-height→0 still animates.
          answer.style.maxHeight = 'none';
          answer.removeEventListener('transitionend', onOpen);
        };
        answer.addEventListener('transitionend', answer._onSmoothToggleEnd);
      }
    });
  });

  /* ---------- Trust row: lock certified-badge height to the closed-state
     accordion height ----------
     .product-info__trust-row used align-items:stretch so the badge matched
     the accordion column's height, but that stretch re-triggers on the grid
     row's live content height — so opening a dropdown grew the row track and
     dragged the badge taller with it. Measure the accordion column once,
     while every <details> is still closed on page load, and pin the badge to
     that fixed pixel height instead, so later opens extend past it. */
  document.querySelectorAll('.product-info__trust-row').forEach(function (row) {
    var badge = row.querySelector('.certified-badge');
    var accordion = row.querySelector('.product-info__accordion');
    if (!badge || !accordion) return;
    var lockedHeight = accordion.getBoundingClientRect().height;
    if (lockedHeight > 0) badge.style.height = lockedHeight + 'px';
  });

  /* ---------- Reel modal: focus trap while open ---------- */
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Tab') return;
    var openModal = document.querySelector('.reel-modal:not([hidden])');
    if (!openModal) return;
    var focusable = openModal.querySelectorAll('button, [href], video, [tabindex]:not([tabindex="-1"])');
    if (!focusable.length) return;
    var first = focusable[0];
    var last = focusable[focusable.length - 1];
    if (e.shiftKey && document.activeElement === first) {
      e.preventDefault();
      last.focus();
    } else if (!e.shiftKey && document.activeElement === last) {
      e.preventDefault();
      first.focus();
    }
  });

  /* ---------- Sell Your Rolex: photo upload (Cloudinary unsigned upload) ----------
     Shopify's native contact form can't process file attachments at all, so
     photos upload directly from the browser straight to Cloudinary (an
     unsigned preset — no secret key is ever exposed client-side) and the
     resulting URLs are packed into a hidden field that submits alongside the
     rest of the native contact-form fields, landing in the same quote email
     merchants already get. Configured per-section in the theme editor
     (sections/sell-rolex-form.liquid schema); if left blank, the widget
     hides itself rather than showing a non-functional dropzone. */
  document.querySelectorAll('[data-photo-upload]').forEach(function (widget) {
    var cloudName = widget.getAttribute('data-cloud-name');
    var uploadPreset = widget.getAttribute('data-upload-preset');
    var maxFiles = parseInt(widget.getAttribute('data-max-files'), 10) || 6;
    if (!cloudName || !uploadPreset) {
      widget.hidden = true;
      return;
    }

    var input = widget.querySelector('[data-photo-input]');
    var grid = widget.querySelector('[data-photo-grid]');
    var status = widget.querySelector('[data-photo-status]');
    var linksField = widget.querySelector('[data-photo-links-input]');
    var form = widget.closest('form');
    var submitBtn = form ? form.querySelector('[data-form-submit]') : null;
    var submitBtnDefaultText = submitBtn ? submitBtn.textContent : '';
    var removeIconSvg = '<svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>';

    var items = []; // { id, url, uploading, failed, previewUrl }

    function uploadingCount() {
      return items.filter(function (i) { return i.uploading; }).length;
    }

    function updateLinksField() {
      var urls = items.filter(function (i) { return i.url; }).map(function (i) { return i.url; });
      linksField.value = urls.join('\n');
    }

    function updateSubmitState() {
      if (!submitBtn) return;
      if (uploadingCount() > 0) {
        submitBtn.disabled = true;
        submitBtn.textContent = 'Uploading photos…';
      } else {
        submitBtn.disabled = false;
        submitBtn.textContent = submitBtnDefaultText;
      }
    }

    function updateStatus() {
      var count = items.length;
      if (count === 0) { status.textContent = ''; return; }
      var failedCount = items.filter(function (i) { return i.failed; }).length;
      var pendingCount = uploadingCount();
      if (pendingCount > 0) {
        status.textContent = 'Uploading ' + pendingCount + ' of ' + count + ' photo' + (count === 1 ? '' : 's') + '…';
      } else if (failedCount > 0) {
        status.textContent = failedCount + ' photo' + (failedCount === 1 ? '' : 's') + ' failed to upload. Remove ' + (failedCount === 1 ? 'it' : 'them') + ' and try again, or continue without.';
      } else {
        status.textContent = count + ' photo' + (count === 1 ? '' : 's') + ' added.';
      }
    }

    function removeItem(id) {
      var idx = -1;
      items.forEach(function (i, index) { if (i.id === id) idx = index; });
      if (idx === -1) return;
      var item = items[idx];
      if (item.previewUrl) URL.revokeObjectURL(item.previewUrl);
      items.splice(idx, 1);
      var el = grid.querySelector('[data-photo-item="' + id + '"]');
      if (el) el.remove();
      updateLinksField();
      updateSubmitState();
      updateStatus();
    }

    function uploadFile(item, file) {
      var formData = new FormData();
      formData.append('file', file);
      formData.append('upload_preset', uploadPreset);
      fetch('https://api.cloudinary.com/v1_1/' + cloudName + '/image/upload', {
        method: 'POST',
        body: formData
      })
        .then(function (res) {
          if (!res.ok) throw new Error('Upload failed');
          return res.json();
        })
        .then(function (data) {
          item.uploading = false;
          item.url = data.secure_url;
          var el = grid.querySelector('[data-photo-item="' + item.id + '"]');
          if (el) el.classList.remove('is-uploading');
          updateLinksField();
          updateSubmitState();
          updateStatus();
        })
        .catch(function () {
          item.uploading = false;
          item.failed = true;
          var el = grid.querySelector('[data-photo-item="' + item.id + '"]');
          if (el) { el.classList.remove('is-uploading'); el.classList.add('is-failed'); }
          updateSubmitState();
          updateStatus();
        });
    }

    function addFiles(fileList) {
      var files = [];
      for (var i = 0; i < fileList.length; i++) {
        if (fileList[i].type && fileList[i].type.indexOf('image/') === 0) files.push(fileList[i]);
      }
      var room = maxFiles - items.length;
      if (room <= 0) {
        status.textContent = 'You can add up to ' + maxFiles + ' photos.';
        return;
      }
      files.slice(0, room).forEach(function (file) {
        var id = 'p' + Date.now() + Math.random().toString(36).slice(2, 7);
        var previewUrl = URL.createObjectURL(file);
        var item = { id: id, url: null, uploading: true, failed: false, previewUrl: previewUrl };
        items.push(item);

        var el = document.createElement('div');
        el.className = 'photo-upload__item is-uploading';
        el.setAttribute('data-photo-item', id);
        el.innerHTML =
          '<img src="' + previewUrl + '" alt="" class="photo-upload__thumb">' +
          '<span class="photo-upload__spinner" aria-hidden="true"></span>' +
          '<button type="button" class="photo-upload__remove" aria-label="Remove photo">' + removeIconSvg + '</button>';
        grid.appendChild(el);
        el.querySelector('.photo-upload__remove').addEventListener('click', function () {
          removeItem(id);
        });

        uploadFile(item, file);
      });
      updateSubmitState();
      updateStatus();
      input.value = '';
    }

    input.addEventListener('change', function () {
      if (input.files && input.files.length) addFiles(input.files);
    });

    var dropzone = widget.querySelector('[data-photo-dropzone]');
    if (dropzone) {
      ['dragenter', 'dragover'].forEach(function (evt) {
        dropzone.addEventListener(evt, function (e) {
          e.preventDefault();
          dropzone.classList.add('is-dragover');
        });
      });
      ['dragleave', 'drop'].forEach(function (evt) {
        dropzone.addEventListener(evt, function (e) {
          e.preventDefault();
          dropzone.classList.remove('is-dragover');
        });
      });
      dropzone.addEventListener('drop', function (e) {
        if (e.dataTransfer && e.dataTransfer.files && e.dataTransfer.files.length) {
          addFiles(e.dataTransfer.files);
        }
      });
    }

    if (form) {
      form.addEventListener('submit', function (e) {
        if (uploadingCount() > 0) {
          e.preventDefault();
          status.textContent = 'Please wait for photos to finish uploading…';
        }
      });
    }
  });
})();
